import type { ReactNode } from 'react';

export type TopbarProps = {
  user: {
    name: string;
    role: string;
  };
  /** Optional extra content rendered after the user avatar (e.g. a settings toggle). */
  extra?: ReactNode;
};

function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

function Topbar({ user, extra }: TopbarProps) {
  return (
    <div className="axi-user-bar" aria-label="账户信息">
      <span className="axi-user-bar__role">管理员</span>
      <span className="axi-user-bar__divider" aria-hidden="true">
        ·
      </span>
      <span className="axi-user-bar__name">{user.name}</span>
      <span className="axi-user-bar__avatar" aria-hidden="true">
        {initialsOf(user.name)}
      </span>
      {extra && <span className="axi-user-bar__extra">{extra}</span>}
    </div>
  );
}

export default Topbar;